import {
    GLOBAL_MAP_INFO_REQUEST,
    GLOBAL_MAP_INFO_SUCCESS,
    GLOBAL_MAP_INFO_ERROR,
} from 'state/actions/global_map'

export const initialState = {
    loading: false,
    loaded: false,
    error: false,
    personal_bonuses_enabled: undefined,
    event_rewards_enabled: undefined,
    battle_schedule_enabled: undefined,
    leaderboards_enabled: undefined,
    context_id: undefined,
    fame_points: undefined,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GLOBAL_MAP_INFO_REQUEST:
        return action.payload.notResetState ? {
            ...state,
            loading: true,
            error: false,
        } : {
            ...initialState,
            loading: true,
            error: false,
        }
    case GLOBAL_MAP_INFO_SUCCESS:
        return {
            ...state,
            ...action.payload,
            loaded: true,
            loading: false,
        }
    case GLOBAL_MAP_INFO_ERROR:
        return {
            ...initialState,
            error: true,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/global_map.js